module.exports = __webpack_public_path__ + "img/b5-1.0875ba4.png";